import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import TTdangkiem from "components/Dangkiem/TTdangkiem.js";
import Dangkiemvien from "components/Dangkiem/Dangkiemvien/Dangkiemvien.js";
import Baocaodangkiem from "components/Dangkiem/Baocaodangkiem.js";
import Dangkiemthongkephuongtien from "components/Dangkiem/Dangkiemthongkephuongtien.js";
export default function BCDangkiem() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Thông tin đơn vị đăng kiểm",
            tabContent: <TTdangkiem />,
          },
          {
            tabName: "Thống kê phương tiện theo tháng",
            tabContent: <Dangkiemthongkephuongtien />,
          },
          {
            tabName: "Đăng kiểm viên",
            tabContent: <Dangkiemvien />,
          },
          {
            tabName: "Báo cáo số liệu tháng",
            tabContent: <Baocaodangkiem />,
          },
        ]}
      />
    </div>
  );
}
